import React from 'react';

import { Box, Grid, IconButton, Typography } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { addThreeDots } from 'helpers/addThreeDots';
import {
  neutralNr100,
  neutralNr20,
  neutralNr40,
  neutralNr50,
  neutralNr80,
  stateErrorRaya
} from 'common/colors';
import DrawerInfoList from 'components/DrawerInfoList';
import { connect } from 'react-redux';
import { getMatchedPlaces } from '../../helpers/getMatchedPlaces';
import PropTypes from 'prop-types';

const DrawerWithSearch = ({
  setIsOpen,
  selectedTitle,
  defaultTitle = '',
  isOpen,
  data,
  setSelectedValue,
  selectedValue,
  id,
  searchable = false,
  handleFetchTeritory = null,
  handleFetchWorkingField,
  searchPlaceHolder = 'cari item...',
  isUpdateData,
  updateDataText,
  isShow = true,
  loanAmount = 0,
  interestLoanInstallmentMin = 0,
  interestLoanInstallmentMax = 0,
  isOpenOtherPurpose = false,
  setIsOpenOtherPurpose = null,
  withoutOther = false,
  isUserLoyalty,
  styleTitle = '',
  serverSide = false,
  onServerSearch = () => {},
  onLoadMore = null,
  hasMore = false,
  isLoadingMore = false,
  showEmpty = false,
  emptyText = 'Data tidak ditemukan',
  disabled = false
}) => {
  const [selected, setSelected] = React.useState('');

  React.useEffect(() => {
    let selectedTitleFilter = '';

    // Filter placeOfBirth data
    const placeOfBirth = selectedValue?.placeOfBirth?.toLowerCase();
    const matchedData = getMatchedPlaces(placeOfBirth, data);

    if (data) {
      if (id === 'jobTitle' || id === 'dailyNormalTransactions')
        selectedTitleFilter = data.filter(title => title.key === selectedTitle);
      else if (id === 'loanPurpose')
        selectedTitleFilter = data.filter(
          title => title.label === selectedTitle
        );
      else if (id === 'placeOfBirth')
        selectedTitleFilter = matchedData ? [matchedData] : [];
      else
        selectedTitleFilter = data.filter(
          title => title.value === selectedTitle
        );
    }

    setSelected(selectedTitleFilter);
  }, [selectedTitle, data]);

  const getSelectedTitle = () => {
    if (selectedTitle) {
      if (typeof selectedTitle === 'object') {
        return selectedTitle?.codeDescription;
      } else {
        if (id === 'loanPurpose' && isOpenOtherPurpose) return selectedTitle;
        if (selected[0]?.label) {
          if (!selected[0]?.label.substring(0, 30)) return defaultTitle;
          else
            return `${selected[0]?.label.substring(0, 30)}${addThreeDots(
              selected[0]?.label
            )}`;
        } else {
          if (!selected[0]?.value.substring(0, 30)) return defaultTitle;
          else
            return `${selected[0]?.value.substring(0, 30)}${addThreeDots(
              selected[0]?.value
            )}`;
        }
      }
    } else if (selectedTitle === 0) {
      if (id === 'numberOfDependents')
        return `${selected[0]?.label.substring(0, 30)}${addThreeDots(
          selected[0]?.label
        )}`;
      else return defaultTitle;
    } else return defaultTitle;
  };

  const handleOpen = () => {
    if (id === 'ksbonTenure') setIsOpen(false);
    else setIsOpen(true);
  };

  const getStyleTitle = () => {
    switch (styleTitle) {
      case 'centerBold':
        return {
          fontFamily: 'Lato',
          fontWeight: 700,
          fontSize: '18px',
          color: neutralNr100,
          padding: '0 5px',
          marginLeft: '8px',
          marginRight: '-30px'
        };
      default:
        return {
          fontFamily: 'Lato',
          fontWeight: 400,
          fontSize: '14px',
          color:
            selectedTitle ||
            (id === 'numberOfDependents' && selectedTitle === 0)
              ? neutralNr100
              : neutralNr50,
          padding: '0 5px',
          marginLeft: '8px'
        };
    }
  };

  return (
    <>
      {isShow && (
        <div>
          <Box
            onClick={!disabled && handleOpen}
            style={{
              border: isUpdateData
                ? '1px solid red'
                : `1px solid ${neutralNr40}`,
              width: '100%',
              height: '55px',
              borderRadius: '8px',
              display: 'flex',
              justifyContent:
                styleTitle === 'centerBold' ? 'center' : 'space-between',
              alignItems: 'center',
              backgroundColor: neutralNr20
            }}
          >
            <Grid
              alignContent="center"
              container
              item
              justifyContent={styleTitle === 'centerBold' && 'center'}
              xs={!(id === 'ksbonTenure') ? 10 : 12}
            >
              <Typography style={getStyleTitle()}>
                {getSelectedTitle()}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              {!(id === 'ksbonTenure') && !disabled && (
                <IconButton>
                  <KeyboardArrowDownIcon style={{ fill: neutralNr80 }} />
                </IconButton>
              )}
            </Grid>
          </Box>
          <DrawerInfoList
            data={data}
            emptyText={emptyText}
            handleFetchTeritory={handleFetchTeritory}
            handleFetchWorkingField={handleFetchWorkingField}
            hasMore={hasMore}
            id={id}
            interestLoanInstallmentMax={interestLoanInstallmentMax}
            interestLoanInstallmentMin={interestLoanInstallmentMin}
            isLoadingMore={isLoadingMore}
            isOpen={isOpen}
            isOpenOtherPurpose={isOpenOtherPurpose}
            isUserLoyalty={isUserLoyalty}
            listTitle={defaultTitle}
            loanAmount={loanAmount}
            onLoadMore={onLoadMore}
            onServerSearch={onServerSearch}
            searchPlaceHolder={searchPlaceHolder}
            searchable={searchable}
            selectedValue={selectedValue}
            serverSide={serverSide}
            setIsOpen={setIsOpen}
            setIsOpenOtherPurpose={setIsOpenOtherPurpose}
            setSelectedValue={setSelectedValue}
            showEmpty={showEmpty}
            withoutOther={withoutOther}
          />
          {isUpdateData && (
            // eslint-disable-next-line react/jsx-no-undef
            <Grid
              alignItems="center"
              container
              direction="row"
              style={{
                fontFamily: 'Lato',
                fontWeight: 400,
                fontSize: 10,
                lineHeight: '16px',
                color: stateErrorRaya,
                marginLeft: '14px',
                marginTop: '3px'
              }}
            >
              <Grid item>
                <img
                  src="/images/assets/warning_update_data.svg"
                  style={{ margin: 'auto', display: 'block' }}
                />
              </Grid>
              <Grid item style={{ marginLeft: '5px' }}>
                {updateDataText}
              </Grid>
            </Grid>
          )}
        </div>
      )}
    </>
  );
};

const mapStatesToProps = states => {
  return {
    isUserLoyalty: states.loanApply.appInqRes.isUserLoyalty
  };
};

DrawerWithSearch.propTypes = {
  data: PropTypes.array,
  defaultTitle: PropTypes.string,
  emptyText: PropTypes.string,
  handleFetchTeritory: PropTypes.func,
  handleFetchWorkingField: PropTypes.func,
  hasMore: PropTypes.bool,
  id: PropTypes.string,
  interestLoanInstallmentMax: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  interestLoanInstallmentMin: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  isLoadingMore: PropTypes.bool,
  isOpen: PropTypes.bool,
  isOpenOtherPurpose: PropTypes.bool,
  isShow: PropTypes.bool,
  isUpdateData: PropTypes.bool,
  isUserLoyalty: PropTypes.string,
  loanAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onLoadMore: PropTypes.func,
  onServerSearch: PropTypes.func,
  searchPlaceHolder: PropTypes.string,
  searchable: PropTypes.bool,
  selectedTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  selectedValue: PropTypes.shape({
    placeOfBirth: PropTypes.string
  }),
  serverSide: PropTypes.bool,
  setIsOpen: PropTypes.func.isRequired,
  setIsOpenOtherPurpose: PropTypes.func,
  setSelectedValue: PropTypes.func,
  showEmpty: PropTypes.bool,
  styleTitle: PropTypes.string,
  updateDataText: PropTypes.node,
  withoutOther: PropTypes.bool
};

export default connect(mapStatesToProps)(DrawerWithSearch);
